/**
 * A meeting counts as past once its end time has passed.
 * End time: end_time, else the end of an "HH:MM-HH:MM" event_time,
 * else start + 1 hour, else end of the day.
 */
export function eventEndDate(
  eventDate: string,
  eventTime?: string | null,
  endTime?: string | null,
): Date {
  const [y, m, d] = eventDate.split("-").map(Number);
  const parse = (t?: string | null) => {
    const match = t?.match(/(\d{1,2})[:.](\d{2})/);
    return match ? [Number(match[1]), Number(match[2])] : null;
  };
  const end = parse(endTime) ?? parse(eventTime?.split("-")[1]);
  if (end) return new Date(y, m - 1, d, end[0], end[1]);
  const start = parse(eventTime);
  if (start) return new Date(y, m - 1, d, start[0] + 1, start[1]);
  return new Date(y, m - 1, d, 23, 59, 59);
}

export function isEventPast(
  eventDate: string,
  eventTime?: string | null,
  endTime?: string | null,
  now: Date = new Date(),
): boolean {
  return eventEndDate(eventDate, eventTime, endTime).getTime() <= now.getTime();
}
